import { render, staticRenderFns } from "./pressing.vue?vue&type=template&id=d51a48bc&scoped=true"
import script from "./pressing.vue?vue&type=script&lang=js"
export * from "./pressing.vue?vue&type=script&lang=js"
import style0 from "./pressing.vue?vue&type=style&index=0&id=d51a48bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51a48bc",
  null
  
)

export default component.exports